export class CollabImagesServiceV2 {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    async request(input, init) {
        const base = new URL(this.baseUrl.toString());
        // Asegura que base.pathname termine en "/"
        if (!base.pathname.endsWith("/")) {
            base.pathname += "/";
        }
        // Convierte input a string y remueve "/" inicial si existe
        const relativePath = input instanceof URL
            ? input.pathname
            : input.startsWith("/")
                ? input.slice(1)
                : input;
        // Combina pathname de base con el relativePath
        base.pathname += relativePath;
        const res = await fetch(base.toString(), { ...init, credentials: 'include' });
        if (!res.ok) {
            const contentType = res.headers.get("content-type");
            const errorBody = contentType?.includes("application/json")
                ? await res.json()
                : await res.text();
            throw new Error(`Error ${res.status}: ${JSON.stringify(errorBody)}`);
        }
        if (res.status === 204)
            return undefined;
        if (res.headers.get("content-type")?.includes("application/json")) {
            return res.json();
        }
        else {
            // @ts-expect-error allow for Buffer data
            return res.arrayBuffer();
        }
    }
    async removeImage(id) {
        return this.request(`/collab-images/${id}`, {
            method: 'DELETE'
        });
    }
    async getGoogleDrive() {
        const data = await this.request('/google-drive/storage');
        return data;
    }
    // GET /:id → raw image data
    async getImage(id) {
        return this.request(`/${id}`);
    }
    // GET /:id/meta → metadata + dataURL
    async getImageMeta(id) {
        return this.request(`/collab-images/${id}/meta`);
    }
    // POST /group/:id/ping
    async pingGroup(id) {
        await this.request(`/collab-images/group/${id}/ping`, {
            method: "POST"
        });
    }
    // GET /group/:id → list of images with dataURL
    async getGroupImages(id) {
        return this.request(`/collab-images/group/${id}`);
    }
    // POST /group/:id/file → upload image (Blob or File)
    async uploadImageFile(groupId, file) {
        const formData = new FormData();
        formData.append("file", file);
        return this.request(`/collab-images/group/${groupId}/file`, {
            method: "POST",
            body: formData
        });
    }
    // POST /group/:id/url → upload image by URL
    async uploadImageFromUrl(groupId, url) {
        return this.request(`/collab-images/group/${groupId}/url`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ url })
        });
    }
}
